import { render, staticRenderFns } from "./SCalculator.vue?vue&type=template&id=88bb912e&scoped=true"
import script from "./SCalculator.vue?vue&type=script&lang=js"
export * from "./SCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bb912e",
  null
  
)

export default component.exports